import React from 'react'
import { Select } from '@mantine/core'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

const CustomSelect = ({placeholder, options, label, defaultValue, onChange, style}: any) => {

  
    return (
        <Select
            variant="unstyled" 
            aria-label={label} 
            className='mt-1'
            placeholder={placeholder} 
            defaultValue={defaultValue}
            rightSection={<ExpandMoreIcon />}
            rightSectionWidth={30}
            styles={ { ...style, rightSection: { pointerEvents: 'none' }}  }
            data={options}
            onChange={onChange}
        />
    )
}

export default CustomSelect;